/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgWorkersBundled = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.07 1.92h1.238l4.466 6.103-4.355 5.896H6.176l4.357-5.899-4.464-6.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.029 7.992l3.213 4.302-.62.84-3.62-4.847.003-.603 3.604-4.711.616.841-3.196 4.178zM9.7 1.92H8.447l4.53 6.026-4.532 5.973h1.256l4.301-5.67.002-.602-4.306-5.728z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25 6v1.5h1.5v1h-1.5V10h-1V8.5h-1.5v-1h1.5V6h1z"
}));

export default SvgWorkersBundled;